import React, { useState, useEffect } from "react";
import GetAPI from "../../APICalls/GetAPI";
import PostAPI from "../../APICalls/PostAPI";
import moment from "moment";
import "./corporateOrderLink.css";
import { ThreeCircles } from "react-loader-spinner";
import CorporateFeedback from "./CorporateFeedback";
import { Modal, Button } from "react-bootstrap";

const calculateOrderStatus = (orderBy) => {
  const currentTime = moment().tz("Asia/Kolkata"); // Get current time in IST
  const orderByTime = moment(orderBy, "hh:mm A").tz("Asia/Kolkata");

  if (currentTime.isAfter(orderByTime)) {
    return { status: "Closed", timeLeft: "00:00" };
  } else {
    const duration = moment.duration(orderByTime.diff(currentTime));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    return { status: "Order before", timeLeft: `${hours}h ${minutes}m` };
  }
};

const CorporateOrderLink = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const emailID = urlParams.get("emailID");
  const [data, setData] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [menuData, setMenuData] = useState({});
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(() => localStorage.getItem("userName") || "");
  const [phoneNumber, setPhoneNumber] = useState(() => localStorage.getItem("phoneNumber") || "");
  const [otpValue, setOtpValue] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(() => localStorage.getItem("phoneNumber") || false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [currentFeedBackID, setCurrentFeedBackID] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  let environment = process.env.REACT_APP_NODE_ENV;
  let corporateAPI, corporateOrderAPI, corporateWeeklyMenuApi, otpApi, corporateFeedbackAPI;
  if (environment === "PRODUCTION" || environment === undefined) {
    corporateAPI = process.env.REACT_APP_PROD_CORPORATE;
    corporateOrderAPI = process.env.REACT_APP_PROD_CORPORATEORDER;
    corporateWeeklyMenuApi = process.env.REACT_APP_PROD_CORPORATEWEEKLYMENU;
    otpApi = process.env.REACT_APP_PROD_OTP_SERVICE;
    corporateFeedbackAPI = process.env.REACT_APP_PROD_CORPORATEFEEDBACK;
  } else {
    corporateAPI = process.env.REACT_APP_DEV_CORPORATE;
    corporateOrderAPI = process.env.REACT_APP_DEV_CORPORATEORDER;
    corporateWeeklyMenuApi = process.env.REACT_APP_DEV_CORPORATEWEEKLYMENU;
    otpApi = process.env.REACT_APP_DEV_OTP_SERVICE;
    corporateFeedbackAPI = process.env.REACT_APP_DEV_CORPORATEFEEDBACK;
  }

  const menuDataCall = () => {
    let corporateURL = corporateAPI + "?emailID=" + emailID;

    GetAPI(corporateURL)
      .then((response) => {
        if (response.data.statusCode === 200 && response.data.body.length > 0) {
          setData(response.data.body);
          response.data.body.forEach((item) => {
            const completeAPI =
              corporateWeeklyMenuApi +
              "?uuID=" +
              item.uuID +
              "&date=" +
              moment().add(1, "day").format("YYYY-MM-DD");
            setLoading(false);
            GetAPI(completeAPI)
              .then((res) => {
                if (res.data.statusCode === 200 && res.data.body) {
                  const { uuID, date, ...menu } = res.data.body;
                  setMenuData((prevMenuData) => ({
                    ...prevMenuData,
                    [item.menuID]: menu,
                  }));
                }
              })
              .catch((e) => {
                console.error(e);
              });
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
      });
  };

  useEffect(() => {
    if (emailID) {
      menuDataCall();
    }
  }, [emailID]);

  // Handle name input and store in localStorage
  const handleNameChange = (e) => {
    const name = e.target.value;
    setUserName(name);
    localStorage.setItem("userName", name);
  };

  const handlePhoneChange = (e) => {
    const number = e.target.value;
    if (number.length <= 10) {
      setPhoneNumber(number);
    }
  };

  const callAPI = () => {
    const postData = { userMobile: "+91".concat(phoneNumber), otpType: "SMS" };

    PostAPI(otpApi, postData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          setOtpValue(response.data.body);
          setShowOtpSection(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const verifyNumber = () => {
    if (enteredOtp == otpValue) {
      alert("Number verified successfully!");
      setShowOtpSection(false);
      setIsPhoneVerified(true);
      localStorage.setItem("phoneNumber", phoneNumber);
    } else {
      alert("Wrong OTP, please try again.");
    }
  };

  const handlePlaceOrder = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmOrder = () => {
    setLoading(true);
    if (selectedMenu && userName) {
      const items = [
        {
          chefPrice: selectedMenu.chefPrice,
          description: selectedMenu.menuDesc,
          itemType: selectedMenu.preference,
          menuID: selectedMenu.menuID,
          menuName: selectedMenu.menuName,
          menuPrice: selectedMenu.sellingPrice,
          quantity: 1,
        },
      ];
      const dataToPost = {
        orderedItems: items,
        appVersion: "N/A",
        chefID: selectedMenu.chefID,
        itemsType: selectedMenu.preference,
        cuisine: selectedMenu.cuisine,
        companyAddress: selectedMenu.companyAddress,
        companyLat: selectedMenu.companyLat,
        companyLng: selectedMenu.companyLng,
        phoneNumber: phoneNumber,
        companyName: selectedMenu.companyName,
        craverName: userName,
        chefDetails: selectedMenu.chefDetails,
        userID: selectedMenu.userID,
        clientID: selectedMenu.clientID,
        status: selectedMenu.status,
        deliveryDate: moment().add(1, "day").format("YYYY-MM-DD"),
        deliverBy:
          selectedMenu.timeSlot +
          " " +
          moment().add(1, "day").format("YYYY-MM-DD"),
        menuType: selectedMenu.menuType,
        paymentStatus: "CREDIT",
        sellingPrice: selectedMenu.sellingPrice,
        chefPrice: selectedMenu.chefPrice,
        menuID: selectedMenu.menuID,
        menuDesc: selectedMenu.menuDesc,
        quantity: 1,
        uuID: selectedMenu.uuID,
        status: "ACCEPTED",
        orderType: "CORPORATE",
      };

      PostAPI(corporateOrderAPI, dataToPost)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            alert("Successfully Placed order!!!");
            setSelectedMenu(null);
          } else {
            alert("Failed to place order, please try again later!!!");
          }
          setLoading(false);
          setShowConfirmModal(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          alert("Failed to place order, please try again later!!!");
        });
    }
  };

  const handleFeedback = (menu) => {
    setLoading(true);
    const corporateURL =
      corporateFeedbackAPI +
      "?uuID=" +
      menu.uuID +
      "&craverMobile=" +
      phoneNumber +
      "&type=CRAVERFEEDBACK";
    GetAPI(corporateURL)
      .then((response) => {
        if (response.data.statusCode === 200 && response.data.body.orderID) {
          setCurrentFeedBackID(response.data.body.orderID);
          setShowFeedbackModal(true);
        } else {
          alert(response.data.body.comment);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
      });
  };

  return (
    <div className="corporateOrderLink container mt-4">
      {loading && (
        <div className="spinnerContainer">
          <div className="spinner">
            <ThreeCircles
              color="blue"
              height={110}
              width={110}
              ariaLabel="three-circles-rotating"
            />
          </div>
        </div>
      )}
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1" style={{ fontWeight: "bold" }}>
          Enter Full Name
        </span>
        <input
          type="text"
          className="form-control"
          id="userNameInput"
          value={userName}
          onChange={handleNameChange}
          placeholder="Enter your name"
          aria-label="Enter your name"
          aria-describedby="basic-addon1"
        />
      </div>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon2" style={{ fontWeight: "bold" }}>
          Phone No
        </span>
        <input
          type ="text"
          className="form-control"
          value={phoneNumber}
          onChange={handlePhoneChange}
          placeholder="Enter 10-digit phone number"
          aria-label="Phone number"
        />
        <button className="btn btn-primary" onClick={callAPI} disabled={phoneNumber.length !== 10}>
          Send OTP
        </button>
      </div>

      {showOtpSection && (
        <div className="input-group mb-3">
          <span className="input-group-text" id="basic-addon3" style={{ fontWeight: "bold" }}>
            Enter OTP
          </span>
          <input
            type="text"
            className="form-control"
            value={enteredOtp}
            onChange={(e) => setEnteredOtp(e.target.value)}
            placeholder="Enter the 4-digit OTP"
            aria-label="OTP"
          />
          <button className="btn btn-success" onClick={verifyNumber}>
            Verify OTP
          </button>
        </div>
      )}
      {data.length > 0 ? (
        <div className="row justify-content-center">
          {data.map((item) => {
            const { status, timeLeft } = calculateOrderStatus(item.closingTime);
            const isClosed = status === "Closed"; // Check if status is "Closed"

            return (
              <div
                className={`col-md-4 ${isClosed ? "greyed-out" : ""}`}
                key={item.menuID}
              >
                <div
                  className={`card text-dark mb-3 ${
                    isClosed ? "disabled-card" : ""
                  } ${selectedMenu === item ? "selected-card" : ""}`}
                >
                  <div className="card-header" onClick={() => !isClosed && setSelectedMenu(item)}>
                    <h4>
                      {item.menuName} - {item.preference}
                    </h4>
                  </div>
                  <div className="row g-0">
                    <div className="col-md-4 col-6 text-center">
                      <img
                        src={item.imageUrl}
                        className="img-fluid"
                        alt="..."
                      />
                      <h6 className="text-muted">{status}</h6>
                      <h6 className="text-muted">{timeLeft}</h6>
                    </div>
                    <div className="col-md-8 col-6">
                      <div className="card-body">
                        <h5 className="card-title">
                          Ordering for {item.menuType}
                        </h5>
                        <h5 className="card-title">
                          Cuisine - {item.cuisine.toUpperCase() === "MIXED" ? "South/North" : item.cuisine}
                        </h5>
                        {menuData[item.menuID] ? (
                          <p className="card-text">
                            <strong>Tomorrow's Menu:</strong>{" "}
                            {`${menuData[item.menuID].sabji}, ${
                              menuData[item.menuID].salad
                            }, ${menuData[item.menuID].bread}, ${
                              menuData[item.menuID].rice
                            }, ${menuData[item.menuID].gravy}`}
                          </p>
                        ) : null}
                        <h5 className="card-title">{item.timeSlot}</h5>
                        <p className="card-text">
                          <small className="text-muted">
                            {item.chefDetails.kitchenName}
                          </small>
                        </p>
                        <u onClick={() => handleFeedback(item)}>Give Feedback</u>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p>Link not active</p>
      )}
      <div className="text-center mt-4">
        <button
          className={`btn btn-block my-5 ${
            selectedMenu && userName && isPhoneVerified ? "btn-success" : "btn-secondary"
          }`}
          onClick={handlePlaceOrder}
          disabled={!selectedMenu || !userName || !isPhoneVerified}
        >
          Place Order
        </button>
      </div>

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to place the order?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmOrder}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFeedbackModal} onHide={() => setShowFeedbackModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CorporateFeedback currentFeedBackID={currentFeedBackID} setCurrentFeedBackID={setCurrentFeedBackID} setFeedbackMenu ={setSelectedMenu} setShowFeedbackModal={setShowFeedbackModal} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CorporateOrderLink;